import filter from "lodash/filter"
import {
  SET_CR_SELECTED_CUSTOMER,
  CLEAR_CONTRACT_RENEWAL_SUBMIT_DETAILS,
  GET_CONTRACT_RENEWAL_ELIGIBILITY_FULFILLED,
  GET_CONTRACT_RENEWAL_ELIGIBILITY_FAILED,
  GET_CONTRACT_RENEWAL_ELIGIBILITY_PENDING,
  SUBMIT_CONTRACT_RENEWAL_FULFILLED,
  SUBMIT_CONTRACT_RENEWAL_FAILED,
  SUBMIT_CONTRACT_RENEWAL_PENDING,
  CANCEL_CONTRACT_RENEWAL_PENDING,
  CANCEL_CONTRACT_RENEWAL_FAILED,
  CANCEL_CONTRACT_RENEWAL_FULFILLED,
  RESET_CONTRACT_RENEWAL_STATUS,
  GET_CONTRACT_RENEWAL_DETAILS_FULFILLED,
  GET_CONTRACT_RENEWAL_DETAILS_FAILED,
  GET_CONTRACT_RENEWAL_DETAILS_PENDING,
  CLEAR_CONTRACT_RENEWAL_DATA,
  ADD_RENEWED_CUSTOMER,
  RESET_USER_ACCOUNT,
} from "constants-lib/actionTypes"

const initialState = {
  getEligibilityStatus: ``,
  contractRenewalSubmitStatus: ``,
  cancelContractRenewalStatus: ``,
  selectedCustomer: {},
  eligibleCustomers: [],
  contractRenewalSubmitDetails: null,
  getDetailsStatus: ``,
  contractRenewalDetails: {},
  renewedCustomers: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CR_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
      }
    case CLEAR_CONTRACT_RENEWAL_SUBMIT_DETAILS:
      return {
        ...state,
        contractRenewalSubmitDetails: null,
        contractRenewalSubmitStatus: "",
        getDetailsStatus: ``,
        contractRenewalDetails: {},
      }
    case GET_CONTRACT_RENEWAL_ELIGIBILITY_FULFILLED:
      return {
        ...state,
        getEligibilityStatus: `fulfilled`,
        eligibleCustomers: filter(
          action.payload,
          (eligibility) =>
            !state.renewedCustomers.includes(eligibility?.customerId),
        ),
      }
    case GET_CONTRACT_RENEWAL_ELIGIBILITY_FAILED:
      return {
        ...state,
        getEligibilityStatus: `failed`,
      }
    case GET_CONTRACT_RENEWAL_ELIGIBILITY_PENDING:
      return {
        ...state,
        getEligibilityStatus: `pending`,
      }
    case SUBMIT_CONTRACT_RENEWAL_FULFILLED:
      return {
        ...state,
        contractRenewalSubmitStatus: `fulfilled`,
        contractRenewalSubmitDetails: action.payload,
        eligibleCustomers: [],
      }
    case SUBMIT_CONTRACT_RENEWAL_FAILED:
      return {
        ...state,
        contractRenewalSubmitStatus: `failed`,
      }
    case SUBMIT_CONTRACT_RENEWAL_PENDING:
      return {
        ...state,
        contractRenewalSubmitStatus: `pending`,
      }
    case CANCEL_CONTRACT_RENEWAL_PENDING:
      return {
        ...state,
        cancelContractRenewalStatus: `pending`,
      }
    case CANCEL_CONTRACT_RENEWAL_FAILED:
      return {
        ...state,
        cancelContractRenewalStatus: `failed`,
      }
    case CANCEL_CONTRACT_RENEWAL_FULFILLED:
      return {
        ...state,
        cancelContractRenewalStatus: `fulfilled`,
      }
    case RESET_CONTRACT_RENEWAL_STATUS:
      return {
        ...state,
        cancelContractRenewalStatus: ``,
      }
    case GET_CONTRACT_RENEWAL_DETAILS_FULFILLED:
      return {
        ...state,
        getDetailsStatus: `fulfilled`,
        contractRenewalDetails: action.payload,
      }
    case GET_CONTRACT_RENEWAL_DETAILS_FAILED:
      return {
        ...state,
        getDetailsStatus: `failed`,
      }
    case GET_CONTRACT_RENEWAL_DETAILS_PENDING:
      return {
        ...state,
        getDetailsStatus: `pending`,
      }
    case CLEAR_CONTRACT_RENEWAL_DATA:
      return {
        ...state,
        getEligibilityStatus: ``,
        contractRenewalSubmitStatus: ``,
        cancelContractRenewalStatus: ``,
        selectedCustomer: {},
        eligibleCustomers: [],
        contractRenewalSubmitDetails: null,
        getDetailsStatus: ``,
        contractRenewalDetails: {},
      }
    case ADD_RENEWED_CUSTOMER:
      return {
        ...state,
        renewedCustomers: [...state.renewedCustomers, action.payload],
      }
    case RESET_USER_ACCOUNT:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
